<template>
  <section>
    <main
    class="main animated fadeIn faster"
    :class="{ 'expand-main': isMenuCollapse }"
    >
    <div class="contenedor py-0">
      <div
      class="d-flex align-items-center justify-content-center w-100"
      v-if="loading=false"
      >
      <LoadingSpinner />
    </div>
    <!-- Select users bdr -->
        <div class="mx-2" v-else>
          <h4>Booker Commission</h4>
          <div class="row">

          
          <div class="col-md-4 my-2 card p-2" v-if="!isBdrUser()">
            <div class="w-100 input-group input-group-sm p-1 treeselect-wrapper " v-if="!isBdrUser()">
              <div class="input-group-prepend">
                <span class="input-group-text" id="inputGroup-sizing-sm"
                  >BDR</span
                >
              </div>              
              <treeselect
                v-model="bdr_user_id"
                :options="bdr_users"
                :multiple="false"
                :clearable="false"
                :normalizer="normalizeOptions"
                class="form-control"
                @input="changeBDR"
              >
              </treeselect>            
            </div>
            </div>

            <!-- Select year to filter-->
            <div class="col-md-2 my-2 card p-2">
              <div class="w-100 input-group input-group-sm p-1">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="inputGroup-sizing-sm">
                    {{ $t("lang.label.year")}}

                  </span>
                </div>
                <date-picker
                  id="yearPicker"
                  class="form-control"
                  v-model="filterYear"
                  :config="datePickerConfig"
                  placeholder="Año"
                  @dp-change="onFilterDateChange"
                ></date-picker>
              </div>
            </div>

            <!-- Select Fake filter-->
            <div class="col-md-2 my-2 card p-2">
              <div class="w-100 input-group input-group-sm p-1">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="inputGroup-sizing-sm">Fake</span>
                </div>
                <select
                  v-model="filterFake"
                  class="form-control"
                  @change="onFilterDateChange"
                >
                  <option value="-1">All</option>
                  <option value="0">No</option>
                  <option value="1">Yes</option>
                </select>
              </div>
            </div>

          </div>

            <!-- <div class="input-group-prepend w-25 mx-5">
              <span class="input-group-text p-1" id="inputGroup-sizing-sm"
                >BDR</span
                >
              <treeselect
              v-model="bdr_user_id"
              :options="bdr_users"
              :multiple="false"
              :clearable="false"
              :normalizer="normalizeOptions"
              class="form-control inline-table"
              @input="changeBDR"
              >
              </treeselect>
            </div> -->


        

          <div class="card p-2 mb-2">
            <div class="table-responsive px-4 mt-4">
              <div class="row" v-if="Object.entries(opportunities).length == 0">      
                <div class="col-12 col-md-10 offset-md-1 text-center " >
                  <div class="alert alert-primary mx-5 my-2 px-2 py-4 ">
                    <h6>
                      <i class="fas fa-exclamation-triangle mr-2"></i>
                      {{ $t("lang.label.nothingplannedatthemoment")}}
                    </h6>
                  </div>
                </div>
              </div>
              <table
                clsas="table table-hover card-style min-width-table card-style"
                width="100%"
              >
                <template v-for="(listYear, year) in opportunities">
                  <tr
                    :key="year"
                    v-if="
                      $options.lastYear == undefined ||
                      $options.lastYear != year
                    "
                  >
                    <td colspan="6">
                      {{ year }}
                    </td>
                  </tr>
                  <template v-for="(listMonth, month) in listYear">
                    <template class="pb-2">
                      <tr
                        :key="month"
                        class="accordion"
                        id="accordionlocation"
                        v-if="
                          $options.lastMonth == undefined ||
                          $options.lastMonth != month
                        "
                      >
                        <td :colspan="totalColumns">
                          <div
                            class="p-2 mt-3 bg-light w-100 align-left"
                            type="button"
                            data-toggle="collapse"
                            :data-target="'#collapseLocation' + year + month"
                            aria-expanded="false"
                            :aria-controls="'collapseLocation' + year + month"
                          >
                            <span> {{ getLabelMonth(month) }} </span>

                            <span
                              class="badge badge-warning ml-2"
                              v-if="
                                absent[year] !== undefined &&
                                absent[year][month] !== undefined
                              "
                              >{{ $t("lang.refuse.absentlabel") }}
                              {{ absent[year][month].total }}</span
                            >

                            <span
                              v-if="
                                refused[year] !== undefined &&
                                refused[year][month] !== undefined
                              "
                              class="badge badge-danger ml-2"
                              >{{ $t("lang.refuse.refused") }}
                              {{ refused[year][month].total }}</span
                            >

                            <span
                              v-if="
                                upComing[year] !== undefined &&
                                upComing[year][month] !== undefined
                              "
                              class="badge badge-secondary ml-2"
                            >
                              {{ $t("lang.label.upcoming") }}
                              {{ upComing[year][month].total }}</span
                            >

                            <span
                              v-if="
                                active[year] !== undefined &&
                                active[year][month] !== undefined
                              "
                              class="badge badge-success text-white ml-2"
                              >{{ $t("lang.refuse.valid") }}
                              {{ active[year][month].total }}</span
                            >

                            <strong
                              v-if="hasPermissions('manageBilling')"
                              class="float-right"
                              >Total: {{ getTotal(year, month) }} € TTC</strong
                            >
                          </div>
                          <div class="dropdown-divider"></div>
                        </td>
                      </tr>

                      <tbody
                        wdth="100%"
                        :key="year + month"
                        :id="'collapseLocation' + year + month"
                        class="collapse"
                        :aria-labelledby="'collapseLocation' + year + month"
                        data-parent="#accordionlocation"
                      >
                        <tr>
                          <th class="small">
                            <b>{{ $t("lang.label.status") }}</b>
                          </th>
                          <th class="small">
                            <b>{{ $t("lang.column.owner") }}</b>
                          </th>
                          <th class="small">
                            <b
                              >{{ $t("lang.label.meeting") }} /
                              {{ $t("lang.label.companyname") }}</b
                            >
                          </th>
                          <th class="small">
                            <b>{{ $t("lang.appointments.meetingdate") }}</b>
                          </th>
                          <th class="small">
                            <b>{{ $t("lang.appointments.billingdate") }}</b>
                          </th>
                          <th class="small pl-3">
                            <b>{{ $t("lang.column.client") }}</b>
                          </th>
                          <th
                            class="small text-right"
                            v-if="hasPermissions('manageBilling')"
                          >
                            <b>Commission Meeting</b>
                          </th>
                        </tr>
                        <tr
                          v-for="(opp, index) in listMonth"
                          :key="year + month + index"
                        >
                          <td>
                            <span :class="getClass(opp)" class="mr-3">{{
                              getText(opp)
                            }}</span>
                          </td>
                          <td>
                            <span class="badge badge-primary mr-2">
                              {{ opp.owner_name }} </span
                            >
                          </td>
                          <td>
                            <a
                              v-if="true"
                              class="text-primary mr-1"
                              target="_blank"
                              :href="'/opportunities/' + opp.link_id"
                              >{{ opp.business_name }}
                            </a>
                            <small v-if="opp.is_fake == '1'" class="badge badge-danger">FAKE</small>
                          </td>
                          <td>
                            <small>{{
                              opp.real_event_date != null
                                ? opp.real_event_date
                                : opp.event_date
                            }}</small>
                          </td>
                          <td>
                            <small>{{ opp.payment_date }}</small>
                          </td>
                          <td>
                            <small class="ml-3" v-if="opp.client_id">
                              <a
                                class="text-primary"
                                target="_blank"
                                :href="'/clients/' + opp.client_id"
                                >{{ opp.client_name }}
                              </a>
                            </small>
                          </td>
                          <td
                            class="text-right"
                            v-if="hasPermissions('manageBilling')"
                          >
                            <!-- Muestro icono tipo reloj -->
                             <template v-if="opp.waiting">
                               <span
                                  class="icon-clock-o ml-3 mr-2"                              
                                  > 
                              </span>
                            <strong class="mr-1">€</strong>                       
                            </template>      
                            <strong v-else>{{ opp.commission_meeting }} € </strong>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                    <template :set="($options.lastMonth = month)"></template>
                  </template>
                  <template :set="($options.lastYear = year)"></template>
                </template>
              </table>
            </div>
          </div>
        </div>
      </div>
    </main>
  </section>
</template>
<script>
import { billingsService, usersService } from "@/_services";
import { mapState, mapActions } from "vuex";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import moment from "moment";
import { set } from "core-js/core/dict";

export default {
  data() {
    return {
      bdr_users: null,
      selectUserBdr: false,
      bdr_user_id: null,
      userId: null, //'26625',
      targetId: "0",
      loading: true,
      opportunities: {},
      total: {},
      active: {},
      refused: {},
      totalexported: {},
      absent: {},
      upComing: {},
      totalexp: 0,
      billingProfile: {},
      list: [],
      filterYear: moment().format("YYYY"),
      filterFake: "-1",
      datePickerConfig: {
        format: "YYYY",
        viewMode: "years",
        minDate: moment().subtract(5, "year"),
        maxDate: moment().endOf("year"),
      },
    };
  },
  props: {
    //   userId: {
    //     type: String,
    //     default: null,
    //   },
    //   targetId: {
    //     type: String,
    //     default: '0'
    //   }
  },
  components: {
    LoadingSpinner,
    Treeselect,
  },
  lastYear: undefined,
  lastMonth: undefined,
  created() {
    this.getBillingProfile();
    this.getData(this.bdr_user_id, this.filterYear, this.filterFake);
    this.getUserBdr();
  },
  mounted() {
    this.setHeader();
  },
  computed: {
    ...mapState({
      statsHeaderBar: (state) => state.campaigns.statsHeaderBar.data,
      isMenuCollapse: (state) => state.sidebar.isNavOpen,
      currentUser: (state) => state.authentication.user,
    }),
    user() {
      return this.$store.state.authentication.user;
    },
    vat() {
      return this.billingProfile.country_id == 73 ? 1.2 : 1;
    },
    totalColumns() {
      if (this.hasPermissions("manageBilling") && this.vat > 1) {
        return 8;
      }
      return 7;
    },
  },

  methods: {
    ...mapActions("headertopbar", {
         setCurrentRoute:"setRoute",
         setCurrentRouteChild:"setRouteChild"
    }),
    setHeader() {
      this.setCurrentRoute({ page: "booker-commission", label: 'Booker Commission' });
    },
    getUserBdr() {
      this.selectUserBdr = false;
      usersService
        .getBdrs()
        .then((res) => {
          this.bdr_users = res.result;
          this.selectUserBdr = true;
        })
        .catch((err) => consolelog(err));
    },
    normalizeOptions(node){
      return {
        id: node.id,
        label: node.name
      };
    },
    changeBDR() {
      // this.loading = true;
      // this.statsClient = {};
      // this.statsDate = [];
      // this.parents = [];
      // this.statsType = [];

      //const userBdr = this.isBdrUser() ? this.currentUser.id : this.bdr_user_id

      this.getData(this.bdr_user_id, this.filterYear, this.filterFake);
    },
    onFilterDateChange() {
      this.getData(this.bdr_user_id, this.filterYear, this.filterFake);
    },
    isBdrUser() {
      return (
        this.currentUser.team_role_id == 2 && this.currentUser.role_id == 2
      );
    },
    hasPermissions(perm) {
      return this.$store.getters["authentication/hasPermissions"](perm);
    },
    hasData(year, month) {
      return (
        (this.refused !== undefined &&
          this.refused[year] !== undefined &&
          this.refused[year][month] !== undefined) ||
        (this.active !== undefined &&
          this.active[year] !== undefined &&
          this.active[year][month] !== undefined) ||
        (this.absent !== undefined &&
          this.absent[year] !== undefined &&
          this.absent[year][month] !== undefined) ||
        (this.totalexported !== undefined &&
          this.totalexported[year] !== undefined &&
          this.totalexported[year][month] !== undefined)
      );
    },
    getBillingProfile() {
      this.billingProfile = {
        name: "sdsfsdf",
        legal_representative: "sdfsfsdf",
        address: "sdfsdfsfsdf",
        country_id: 73,
        contact_name: "dddddd",
        contact_email: "aaaaaa",
      };
      // billingsService.getBillingProfile(this.userId).then((result) => {
      //   if (result) {
      //     this.billingProfile = result;
      //   } else {
      //     this.billingProfile = {
      //       name: "",
      //       legal_representative: "",
      //       address: "",
      //       country_id: 73,
      //       contact_name: "",
      //       contact_email: "",
      //     };
      //     this.loading = false;
      //   }
      // });
    },
    getData(bdr_user_id, year, fake) {
      (this.opportunities = {}),
        (this.total = {}),
        (this.active = {}),
        (this.loading = true);
        this.absent = {};
        this.refused = {};
        this.upComing = {};
      this.userId = bdr_user_id ? bdr_user_id : this.currentUser.id;
      billingsService
        .getCommissionDetail(this.userId, this.targetId, year, fake)
        .then((result) => {
          this.list = result.list;

          if (this.targetId != "0") {
            result.list = result.list.filter(
              (el) => el.target_id == this.targetId
            );
          }

          if (bdr_user_id) {
            result.list = result.list.filter(
              (el) => el.bdr_user_id == bdr_user_id
            );
          }

          result.list.forEach((item) => {
            if (this.opportunities[item.event_year_created] == undefined) {
              this.opportunities[item.event_year_created] = {};
            }
            if (
              this.opportunities[item.event_year_created][
                item.event_month_created
              ] == undefined
            ) {
              this.opportunities[item.event_year_created][
                item.event_month_created
              ] = [];
            }

            this.opportunities[item.event_year_created][
              item.event_month_created
            ].push(item);

            if (item.link_status_reason_id == 35) {
              item.commission_meeting = 0;
              if (this.absent[item.event_year_created] == undefined) {
                this.absent[item.event_year_created] = {};
              }
              if (
                this.absent[item.event_year_created][
                  item.event_month_created
                ] == undefined
              ) {
                this.absent[item.event_year_created][item.event_month_created] =
                  { total: 0 };
              }
              this.absent[item.event_year_created][item.event_month_created]
                .total++;
            } else if (item.link_status_reason_id == 34) {
              item.commission_meeting = 0;
              if (this.refused[item.event_year_created] == undefined) {
                this.refused[item.event_year_created] = {};
              }
              if (
                this.refused[item.event_year_created][
                  item.event_month_created
                ] == undefined
              ) {
                this.refused[item.event_year_created][
                  item.event_month_created
                ] = { total: 0 };
              }
              this.refused[item.event_year_created][item.event_month_created]
                .total++;
            } else {
              if (item.amount == undefined) {
                item.commission_meeting = 0;
                item.waiting = true;
                if (this.upComing[item.event_year_created] == undefined) {
                  this.upComing[item.event_year_created] = {};
                }
                if (
                  this.upComing[item.event_year_created][
                    item.event_month_created
                  ] == undefined
                ) {
                  this.upComing[item.event_year_created][
                    item.event_month_created
                  ] = { total: 0 };
                }
                this.upComing[item.event_year_created][item.event_month_created]
                  .total++;
                // item.commission_meeting = 0
              } else {
                if (this.active[item.event_year_created] == undefined) {
                  this.active[item.event_year] = {};
                }
                if (
                  this.active[item.event_year_created][
                    item.event_month_created
                  ] == undefined
                ) {
                  this.active[item.event_year_created][
                    item.event_month_created
                  ] = {
                    total: 0,
                    totalAmount: 0,
                  };
                }

                this.active[item.event_year_created][item.event_month_created]
                  .total++;
                this.active[item.event_year_created][
                  item.event_month_created
                ].totalAmount =
                  this.active[item.event_year_created][item.event_month_created]
                    .totalAmount + parseFloat(item.amount);
              }
            }
          });
        })
        .then((result) => {
          this.loading = false;
          this.$forceUpdate();
        });
    },
    getTotal(year, month) {
      if (this.list) {
        const totals = this.list
          .filter(
            (el) =>
              el.event_year_created == year && el.event_month_created == month
          )
          .map((e) => Number(e.commission_meeting))
          .reduce((counter, currentValue) => {
            return counter + currentValue;
          }, 0);

        return totals;
      } else {
        return 0;
      }
    },
    getCurrentMonth() {
      var d = new Date();
      var weekday = new Array(7);
      weekday[0] = this.$t("lang.label.january");
      weekday[1] = this.$t("lang.label.frebruary");
      weekday[2] = this.$t("lang.label.march");
      weekday[3] = this.$t("lang.label.april");
      weekday[4] = this.$t("lang.label.may");
      weekday[5] = this.$t("lang.label.june");
      weekday[6] = this.$t("lang.label.july");
      weekday[7] = this.$t("lang.label.august");
      weekday[8] = this.$t("lang.label.september");
      weekday[9] = this.$t("lang.label.october");
      weekday[10] = this.$t("lang.label.november");
      weekday[11] = this.$t("lang.label.december");
      return weekday[d.getMonth()];
    },
    getYear() {
      var d = new Date();
      return d.getFullYear();
    },
    getLabelMonth(month) {
      var weekday = new Array(7);
      weekday[1] = this.$t("lang.label.january");
      weekday[2] = this.$t("lang.label.frebruary");
      weekday[3] = this.$t("lang.label.march");
      weekday[4] = this.$t("lang.label.april");
      weekday[5] = this.$t("lang.label.may");
      weekday[6] = this.$t("lang.label.june");
      weekday[7] = this.$t("lang.label.july");
      weekday[8] = this.$t("lang.label.august");
      weekday[9] = this.$t("lang.label.september");
      weekday[10] = this.$t("lang.label.october");
      weekday[11] = this.$t("lang.label.november");
      weekday[12] = this.$t("lang.label.december");
      return weekday[month];
    },
    getClass(opportunity) {
      if (opportunity.link_status_reason_id == 35) {
        return "badge badge-warning";
      }
      if (opportunity.link_status_reason_id == 34) {
        return "badge badge-danger";
      }
      if (opportunity.amount == undefined) {
        return "badge badge-secondary";
      }
      if (opportunity.real_event_date != null) {
        return "icon-dollar text-success";
      }
      return "icon-checkmark text-success";
    },
    getText(opportunity) {
      if (opportunity.link_status_reason_id == 35) {
        return this.$t("lang.refuse.absentlabel");
      }
      if (opportunity.link_status_reason_id == 34) {
        return this.$t("lang.refuse.refused");
      }
      if (opportunity.amount == undefined) {
        return this.$t("lang.label.upcoming");
      }
      return "";
    },
    getPrice(opportunity) {
      return parseFloat(opportunity.amount).toFixed(2);
    },
    getPriceIva(opportunity) {
      return parseFloat(opportunity.amount * this.vat).toFixed(2);
    },
    getPriceContacts(amount) {
      return parseFloat(amount * 0.0).toFixed(2);
    },
    getPriceContactsIva(amount) {
      return parseFloat(amount * 0.0 * this.vat).toFixed(2);
    },
  },
};
</script>
